import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import reducer, {
  NAVBAR_OPEN,
  SET_ACTIVE_REPORT,
  SET_FORM_SELECTIONS,
  SET_SUBMITTED_VALUES,
  SET_PROPERTIES_GROUP_BY
} from '../reducer';

export const initialState = {
  navbarOpen: true,
  formSelections: {
    cropSeasons: [],
    startDate: undefined,
    endDate: undefined,
    properties: [],
    products: [],
    plans: [],
    workOrders: [],
    mapStyle: ''
  },
  submittedValues: {},
  activeReport: null,
  propertiesGroupBy: 'property'
};

export const ReportsContext = createContext(initialState);

const ReportsProvider = ({ children = null }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const toggleNavbar = () => {
    dispatch({
      type: NAVBAR_OPEN,
      payload: !state.navbarOpen
    });
  };

  const setActiveReport = reportSelection => {
    dispatch({
      type: SET_ACTIVE_REPORT,
      payload: reportSelection
    });
  };

  const setFormSelections = selections => {
    dispatch({
      type: SET_FORM_SELECTIONS,
      payload: selections
    });
  };

  const resetFormSelections = () => {
    dispatch({
      type: SET_FORM_SELECTIONS,
      payload: initialState.formSelections
    });
  };

  const getActiveReport = () => {
    return state.activeReport;
  };

  const setSubmittedValues = values => {
    dispatch({
      type: SET_SUBMITTED_VALUES,
      payload: values
    });
  };

  const getSubmittedValues = () => {
    return state.submittedValues;
  };

  const setPropertiesGroupBy = groupBy => {
    dispatch({
      type: SET_PROPERTIES_GROUP_BY,
      payload: groupBy
    });
  };

  return (
    <ReportsContext.Provider
      value={{
        state,
        dispatch,
        toggleNavbar,
        setActiveReport,
        getActiveReport,
        setFormSelections,
        resetFormSelections,
        setSubmittedValues,
        getSubmittedValues,
        setPropertiesGroupBy
      }}
    >
      {children}
    </ReportsContext.Provider>
  );
};

ReportsProvider.propTypes = {
  children: PropTypes.node
};

export default ReportsProvider;
